const { doAction, fail, success } = require('./index');

const REFRESH_TOKEN = 'REFRESH_TOKEN';

module.exports = {
	REFRESH_TOKEN,

	refreshToken(token) {
		const auth = JSON.parse(localStorage.getItem('auth'));

		if (auth) {
			auth.token = token;
			localStorage.setItem('auth', JSON.stringify(auth));
			return {
				type: REFRESH_TOKEN,
				payload: {
					token
				}
			};
		}
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/token.js